<div class="page">

    <div class="page-header">
        <h3 class="page-name">Project List</h3>
        <div class="page-toolbar">
            <dx-select-box [dataSource]="projectHeaderStatus" valueExpr="id" displayExpr="label"
                [value]="projectHeaderStatusValue" (onValueChanged)="projectHeaderStatusValueChange($event)"
                class="outline-round-select tool-select"></dx-select-box>
            <dx-button class="outline-round-btn tool-btn" stylingMode="outlined" text="Reset"></dx-button>
            <dx-button class="outline-round-btn tool-btn" stylingMode="outlined" text="New"></dx-button>
            <dx-button class="outline-round-btn tool-btn" stylingMode="outlined" text="Preference"></dx-button>
            <dx-button class="outline-round-btn tool-btn" stylingMode="outlined" text="Save Filter"></dx-button>
        </div>
    </div>

    <div class="card project-list-block">

        <dx-data-grid id="ProjectList" keyExpr="id" [dataSource]="projectList" class="card" [allowColumnResizing]="true"
            [columnResizingMode]="'widget'" [hoverStateEnabled]="true" [rowAlternationEnabled]="true"
            [columnAutoWidth]="true" [allowColumnReordering]="true">
            <!-- <dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
            <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true"
                [showNavigationButtons]="true" [displayMode]="'full'">
            </dxo-pager> -->
            <dxo-editing mode="batch" [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false"
                [useIcons]="true" [selectTextOnEditStart]="true" [startEditAction]="'click'"> 
            </dxo-editing>
            <dxo-filter-row visible="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-header-filter visible="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true" class="" placeholder="Search..."></dxo-search-panel>
            <dxo-selection selectAllMode="allPages" showCheckBoxesMode="always" mode="multiple"></dxo-selection>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Project List"></dxo-export>
            <dxo-scrolling mode="standard" [showScrollbar]="'always'"></dxo-scrolling>
            <dxi-column type="selection" width="30"></dxi-column>
            <dxi-column dataField="title" caption="Title" cellTemplate="titleCellTemplate" [alignment]="'left'">
            </dxi-column>
            <div *dxTemplate="let d of 'titleCellTemplate'">
                <div class="project-list-title link active tl">
                    <!-- <a routerLink="/production-budget/{{d.data.id}}" class="no-underline" >{{d.value}}</a> -->
                    <span class="link" [id]='"contextLinkId"+d.data.id'
                        (mouseover)="onMouseOverContext(d.data)">{{d.value}}</span>
                </div>
            </div>
            <dxi-column dataField="status" caption="Status" cellTemplate="statusCellTemplate">
                <dxo-lookup [dataSource]="lookup.status" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <div *dxTemplate="let d of 'statusCellTemplate'">
                <div class="project-list-status link active tl">
                    <em class="fa fa-circle f7 mr2 success-color"
                        [ngClass]="{'status-pre-production':d.value==1, 'status-production':d.value==2, 'status-post-production': d.value==3, 'status-released': d.value==4}"></em><span
                        class="project-list-status-text">{{getStatus(d)}}</span>
                </div>
            </div>
            <dxi-column dataField="studio" caption="Studio">
                <dxo-lookup [dataSource]="lookup.studios" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="FY" caption="FY" width="60"></dxi-column>
            <dxi-column dataField="release" caption="Release" dataType="date"></dxi-column>
            <dxi-column dataField="productionType" caption="Production Type">
                <dxo-lookup [dataSource]="lookup.productionTypes" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="WBSProdId" caption="WBS Prod ID"></dxi-column>
            <dxi-column dataField="MPMId" caption="MPM ID"></dxi-column>
            <dxi-column dataField="corporations" caption="Corporation(s)" editCellTemplate="tagBoxEditor"
                [cellTemplate]="cellTemplate" [calculateFilterExpression]="calculateFilterExpression">
                <dxo-lookup [dataSource]="lookup.corporations" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <div *dxTemplate="let cellInfo of 'tagBoxEditor'">
                <dx-tag-box [dataSource]="lookup.corporations" [value]="cellInfo.value" valueExpr="id"
                    displayExpr="label" [showSelectionControls]="true" [maxDisplayedTags]="3" [showMultiTagOnly]="false"
                    applyValueMode="useButtons" [searchEnabled]="true"
                    (onValueChanged)="onTagBoxEditorValueChanged($event, cellInfo)"
                    (onSelectionChanged)="cellInfo.component.updateDimensions()"
                    [inputAttr]="{ 'placeholder': '' }"
                    >
                </dx-tag-box>
            </div>
            <dxi-column dataField="distributors" caption="Distributor(s)">
                <dxo-lookup [dataSource]="lookup.distributors" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="creativeExecutives" caption="Creative Executive(s)" editCellTemplate="tagBoxEditor2"
                [cellTemplate]="cellTemplate2" [calculateFilterExpression]="calculateFilterExpression2">
                <dxo-lookup [dataSource]="lookup.creativeExecutives" valueExpr="id" displayExpr="label"></dxo-lookup>
            </dxi-column>
            <div *dxTemplate="let cellInfo of 'tagBoxEditor2'">
                <dx-tag-box [dataSource]="lookup.corporations" [value]="cellInfo.value" valueExpr="id"
                    displayExpr="label" [showSelectionControls]="true" [maxDisplayedTags]="3" [showMultiTagOnly]="false"
                    applyValueMode="useButtons" [searchEnabled]="true"
                    (onValueChanged)="onTagBoxEditorValueChanged($event, cellInfo)"
                    (onSelectionChanged)="cellInfo.component.updateDimensions()"
                    [inputAttr]="{ 'placeholder': '' }"
                    >
                </dx-tag-box>
            </div>
        </dx-data-grid>
        <dx-context-menu [dataSource]="contextItems" [width]="200" [target]="contextMenuTarget"
            (onItemClick)="contextItemClick($event)">
        </dx-context-menu>
    </div>

</div>